import React, { useState } from "react";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useVisitor } from "../context/VisitorAuthContext";

export const FavouriteButton = ({ slug, variant = "icon" }) => {
  const { visitor, isFavourite, toggleFavourite, openAuth } = useVisitor();
  const [busy, setBusy] = useState(false);
  const active = isFavourite(slug);

  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!visitor) {
      openAuth();
      return;
    }
    setBusy(true);
    try {
      await toggleFavourite(slug);
    } catch (err) {
      toast.error("Could not update your favourites.");
    } finally {
      setBusy(false);
    }
  };

  if (variant === "button") {
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={busy}
        data-testid={`favourite-button-${slug}`}
        aria-pressed={active}
        className={`inline-flex items-center gap-2 font-ui text-xs font-semibold uppercase tracking-wider px-4 py-2.5 rounded-full border transition-colors ${
          active
            ? "bg-[#9E4535] text-[#FAF7F0] border-[#9E4535]"
            : "bg-transparent text-[#9E4535] border-[#9E4535] hover:bg-[#9E4535] hover:text-[#FAF7F0]"
        }`}
      >
        <Heart className={`w-4 h-4 ${active ? "fill-current" : ""}`} />
        {active ? "Saved" : "Save curio"}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      data-testid={`favourite-button-${slug}`}
      aria-label={active ? "Remove from favourites" : "Save to favourites"}
      aria-pressed={active}
      className="absolute top-3 right-3 z-10 w-9 h-9 flex items-center justify-center rounded-full bg-[#FAF7F0]/90 backdrop-blur border border-[#D8CEB9] text-[#9E4535] hover:bg-[#9E4535] hover:text-[#FAF7F0] hover:border-[#9E4535] transition-colors shadow-sm"
    >
      <Heart className={`w-4 h-4 ${active ? "fill-[#9E4535] text-[#9E4535] hover:fill-[#FAF7F0] hover:text-[#FAF7F0]" : ""}`} />
    </button>
  );
};
